import { offsetTimezone } from '../../../services/utils';

function dateTimeFilterFn(
	rows,
	ids,
	filterValue
) {
	if ( filterValue.length === 0 ) {
		return rows;
	}

	let filteredRows = rows.filter( row => {
		return ids.some( id => {
			const rowValue = offsetTimezone( row.values[ id ], 'dateTime' );
			const words = String( filterValue )
				.split( /[^APM0-9/:]/g )
				.filter( i => i.length );

			// only if whole string matches
			return words.every( word => rowValue
				.includes( word ) );
		} );
	} );

	return filteredRows;
}

dateTimeFilterFn.autoRemove = val => !val;

export default dateTimeFilterFn;
